import { CSS } from '@grupoboticario/flora-react'

export const headerDetailRootCss: CSS = {
  height: '0',
  transition: 'height .2s ease-in-out',
  '&[data-will-show-info="true"]': {
    height: '$10',
    '@fullscreen': {
      height: '$7'
    }
  }
}

export const fixedContainerCss: CSS = {
  left: 0,
  position: 'fixed',
  top: '$14',
  transition: '.3s ease-in-out',
  width: '100%',
  zIndex: '$sticky',
  '@fullscreen': {
    top: 0
  }
}

export const sidebarPlaceholderCss: CSS = {
  display: 'none',
  width: '232px',
  '@fullscreen': {
    display: 'block'
  }
}

export const sidebarPlaceholderInnerCss: CSS = {
  width: '232px'
}

export const centerFlexCss: CSS = {
  width: '100%'
}

export const contentRowCss: CSS = {
  width: '100%',
  '@tablet': {
    width: '760px'
  },
  '@fullscreen': {
    width: '1160px'
  }
}

export const chevronPanelCss: CSS = {
  width: '100%',
  '@tablet': {
    background: '$actionableDefault',
    clipPath: 'polygon(0 0, 100% 0, 93% 100%, 0% 100%)',
    width: '680px',
    height: '66px'
  }
}

export const infoPanelCss: CSS = {
  alignItems: 'center',
  background: '$backgroundSecondary',
  display: 'flex',
  justifyContent: 'flex-start',
  padding: '$3 $4',
  textAlign: 'left',
  width: '100%',
  '@tablet': {
    padding: '$3 $5',
    clipPath: 'polygon(0 0, 100% 0, 93.3% 100%, 0% 100%)',
    position: 'relative',
    width: '676px',
    height: '63px'
  }
}

export const infoRowCss: CSS = {
  width: '80%'
}

export const usernameCss: CSS = {
  display: 'block',
  maxWidth: '150px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  '@tablet': { maxWidth: '250px' }
}

export const documentBoxCss: CSS = {
  display: 'none',
  '@tablet': {
    display: 'block'
  }
}

export const displayBlockCss: CSS = {
  display: 'block'
}
